import { pick, get } from 'lodash/fp';

/*
 * If public user is linked
 * use homeless and household total values from guest
 * */
export default (reservationGuestMeta, userOtherInfo) => {
  const guestId = get('guestId', reservationGuestMeta);
  if (guestId) {
    return {
      ...userOtherInfo,
      ...pick(['homeless', 'householdTotal'], reservationGuestMeta)
    };
  }
  return userOtherInfo;
};
